export default __webpack_public_path__ + "static/media/left.d2ddd832.svg";